import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {
    setLoadingPatchIssue,
    patchIssue,
    patchIssueSuccess,
    patchIssueError,
    setLoadingGetIssue,
    getIssue,
    getIssueSuccess,
    getIssueError,
    toggleEditIssueModal
} from '../../actions/IssueActions';
import {TRANSLATE_LOADING_CONTENT} from '../../translates/Translates';
import moment from 'moment';

class EditIssueModal extends Component{
    constructor(props){
        super(props);

        this.state = {
            issue: {}
        }
    }

    componentDidMount = () => {
        this.props.setLoadingGetIssue();
        this.props.getIssue(this.props.issueId).then((response) => {
            this.setState({issue: response.payload.data});
            this.props.getIssueSuccess();
        }).catch(() => {
            this.props.getIssueError();
        })
    }

    onChangeField = (event) => {
        const value = event.target.value;
        const name = event.target.name;
        this.setState((prevState) => {
            let issue = {...prevState.issue};
            issue[name] = value;
            return {
                ...prevState,
                issue
            }
        })
    }

    submitForm = (data) => {
        this.props.setLoadingPatchIssue();
        this.props.patchIssue(data).then((response) => {
            this.props.patchIssueSuccess();
        }).catch(() => {
            this.props.patchIssueError();
        })
    }

    render(){
        return(
            <div className="edit-issue">
                <div id="modal-window-update-record">
                    <div id="modal-window-update-record-content">
                        <button type="button" className="close-button" onClick={() => this.props.toggleEditIssueModal(false, true)}>
                            <i className="fas fa-times"></i>
                        </button>
                        {/*
                        <div className="left-button">
                            <i className="ti-angle-left"></i>
                            <span id="left-button-title">ID: <span id="left-id">1</span></span>
                        </div>

                        <div className="left-children-button">
                            <i className="ti-angle-left"></i>
                            <span id="left-children-button-title"><span id="left-children-id">1</span></span>
                        </div>
                        
                        <div className="middle-children-button">
                            <span id="middle-children-button-title"><span id="middle-children-id">1</span></span>
                        </div>

                        <div className="right-button">
                            <span id="right-button-title"></span> ID: <span id="right-id">3</span> 
                            <i className="ti-angle-right"></i>
                        </div>

                        <div className="right-children-button">
                            <span id="right-children-button-title"></span><span id="right-children-id">3</span> 
                            <i className="ti-angle-right"></i>
                        </div>
                        */}
                        <div className="row table-tier3-update">
                            <div className="col-md-12">
                                <h4>Update of ID: <span>{this.props.issueId}</span></h4>
                                <br/>
                            </div>
                        </div>
                        {this.props.loadingGetIssue ? (
                            <div className="loading-wrapper">
                                <p>{TRANSLATE_LOADING_CONTENT}</p>
                            </div>
                        ) : (
                        <div className="row table-tier3-update">
                            <form method="patch">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-2">
                                            <label>Process:</label>
                                            <select className="process-select" value={this.state.issue.process} name="process" onChange={this.onChangeField}>
                                                <option value="1">CHRA</option>
                                                <option value="2">FA</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label>Line:</label>
                                            <select className="line-select" value={this.state.issue.line} name="line" onChange={this.onChangeField}>
                                                <option value="1">1A</option>
                                                <option value="2">6B</option>
                                                <option value="3">2B</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label>Operation:</label>
                                            <select className="operation-select" value={this.state.issue.operation} name="operation" onChange={this.onChangeField}>
                                                <option value="1">30</option>
                                                <option value="2">70</option>
                                                <option value="3">70,80</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label>When start:</label>
                                            <br/>
                                            <input type="text" className="datepicker-input" value={moment.unix(this.state.issue.when_start).format("DD.MM.YYYY")} name="when_start" onChange={this.onChangeField} />
                                        </div>
                                        <div className="col-md-2">
                                            <label>When close:</label>
                                            <br/>
                                            <input id="update_when_close" type="text" className="datepicker-input" value={moment.unix(this.state.issue.when_close).format("DD.MM.YYYY")} name="when_close" onChange={this.onChangeField} />
                                        </div>
                                        <div className="col-md-2">
                                            <label>Product:</label>
                                            <select className="product-select" value={this.state.issue.product} name="product" onChange={this.onChangeField}>
                                                <option value="1">DAIMLER</option>
                                                <option value="2">BMW</option>
                                                <option value="3">DUCATO</option>
                                                <option value="4">PSA</option>
                                            </select>
                                        </div>
                                    </div>
                                    <br/>
                                    <div className="row">
                                        <div className="col-md-2">
                                            <label>Class:</label>
                                            <select className="class-select" value={this.state.issue.class} name="class" onChange={this.onChangeField}>
                                                <option value="1">123</option>
                                                <option value="2">843</option>
                                                <option value="3">169</option>
                                                <option value="4">843, 819</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label>Line type:</label>
                                            <select className="line-type-select" value={this.state.issue.class} name="class" onChange={this.onChangeField}>
                                                <option value="1">Action</option>
                                                <option value="2">Main</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label>Status:</label>
                                            <select className="status-select" value={this.state.issue.status} name="status" onChange={this.onChangeField}>
                                                <option value="1">Opened</option>
                                                <option value="2">Closed</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label>Who:</label>
                                            <div id="who_magicsuggest"></div>
                                        </div>
                                        <div className="col-md-2">
                                            <label>Issue origin:</label>
                                            <select className="issue-origin-select" value={this.state.issue.issue_origin} name="issue_origin" onChange={this.onChangeField}>
                                                <option value="1">Cross homologation</option>
                                                <option value="2">NPI</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label>Problem category:</label>
                                            <select className="problem-category-select" value={this.state.issue.problem_category} name="problem_category" onChange={this.onChangeField}>
                                                <option value="1">Hardware</option>
                                                <option value="2">Software</option>
                                                <option value="3">Combination</option>
                                            </select>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <label>Failure MODE:</label>
                                            <textarea className="textarea-style" name="failure_mode" onChange={this.onChangeField} value={this.state.issue.failure_mode}></textarea>
                                        </div>
                                        <div className="col-md-3">
                                            <label>Failure CAUSE:</label>
                                            <textarea className="textarea-style" name="failure_cause" onChange={this.onChangeField} value={this.state.issue.failure_cause}></textarea>
                                        </div>
                                        <div className="col-md-3">
                                            <label>Failure EFFECT:</label>
                                            <textarea className="textarea-style" name="failure_effect" onChange={this.onChangeField} value={this.state.issue.failure_effect}></textarea>
                                        </div>
                                        <div className="col-md-3">
                                            <label>Detection:</label>
                                            <textarea className="textarea-style" value={this.state.issue.detection} name="detection" onChange={this.onChangeField}></textarea>
                                        </div>
                                    </div>
                                </div>
                                <button type="button" className="btn waves-effect waves-light btn-block btn-success" id="save-button-update-record" onClick={() => this.submitForm(this.state.issue)}>Uložiť</button>
                            </form>    
                        </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        loadingGetIssue: state.issueReducer.loadingGetIssue
    }
} 

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setLoadingPatchIssue,
        patchIssue,
        patchIssueSuccess,
        patchIssueError,
        setLoadingGetIssue,
        getIssue,
        getIssueSuccess,
        getIssueError,
        toggleEditIssueModal
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditIssueModal);
